export const CUSTOM = 'CUSTOM';
export const TEAM = 'TEAM';
export const USER = 'USER';